const dashboardHR = {
    "view": {
        "label": {
            "allTimeSales": "Prodaja svih vremena",
            "totalToBePaid": "Ukupno za isplatu",
            "promoCoins": "Promo kovanice",
            "promoDownloadCount": "Broj promo preuzimanja",
            "promoFeedbackCount": "Broj promo povratnih informacija",
            "totalDownloads": "Ukupno preuzimanja",
            "totalFeedbacks": "Ukupno povratnih informacija"
        },
        "options": {
            "earnings": {
                "allTime": "Zarada svih vremena",
                "last12Months": "Posljednjih 12 mjeseci"
            },
            "months": {
                "jan": "Sij",
                "feb": "Velj",
                "mar": "Ožu",
                "apr": "Tra",
                "may": "Svi",
                "jun": "Lip",
                "jul": "Srp",
                "aug": "Kol",
                "sep": "Ruj",
                "oct": "Lis",
                "nov": "Stu",
                "dec": "Pro"
            }
        },
        "message": {
            "userWelcomeTitle": "Hej {{firstName}}, dobrodošao natrag na Music Link Platformu.",
            "ownedAndManaged": "Vaš račun je u vlasništvu i upravljan od strane <1>{{ parent_company }}</1>, posjetite našu <3>Stranicu pomoći</3> za više informacija.",
            "completeInformation": "Još niste poslali svoje podatke, molimo <1><strong>Dovršite svoje podatke</strong></1> za nastavak!",
            "notSubscribed": "Niste pretplaćeni na nijedan plan. Pretplatite se sada kako biste otključali puni potencijal Music Link platforme!",
            "accountBlacklisted": "Vaš račun je bio blacklisted nakon pregleda kako smo otkrili da su informacije povezane s vašim računom povezane s jednim od internacionalno blacklisted korisnika u našem sistemu. Stoga smo onemogućili funkciju distribucije za vaš račun.",
        }
    }
};

export default dashboardHR;